// extracted by mini-css-extract-plugin
module.exports = {"Divider":"styles_Divider__26Vmv","ContainerTable":"styles_ContainerTable__2Soqd","ContainerTableColunas":"styles_ContainerTableColunas__3sFVF"};